<template>
    <v-dialog v-model="dialog" max-width="450px">
      <v-btn slot="activator" color="#10940c" class="hidden-xs-only" round large dark>{{ ButtonText }}</v-btn>
      <v-btn slot="activator" color="#10940c" class="hidden-sm-and-up action-button-sm" round dark>{{ ButtonText }}</v-btn>
      <v-card class="form-card">

        <transition name="fade" mode="out-in">

          <div v-if="!formSuccess" key="one">
            <v-form ref="form">
                <div class="form-name1">{{ modalFormHeader }}</div>
                <div class="form-name2">{{ modalFormSubHeader }}</div>
                <div class="form-sub-name">перезвоним в течение 15 минут</div>
                <v-text-field
                  label="Ваш телефон*"
                  v-model="phone"
                  :rules="phoneRules"
                  color="green"
                  class="form-input"
                  required
                ></v-text-field>

                <div>
                  <small class="small">Нажимая на кнопку "{{ modalFormButtonText }}" вы соглашаетесь на обработку
                    <a href="/privacy" class="privacy-link">персональных данных</a>.</small>
                </div>

                <!-- КНОПКА ДЛЯ 600+ -->
                <v-btn
                  class="form-button hidden-xs-only"
                  color="#10940c"
                  large
                  dark
                  round
                  @click="submit"
                >
                  {{ modalFormButtonText }}
                </v-btn>

                <!-- КНОПКА ДЛЯ 600- -->
                <v-btn
                  class="form-button hidden-sm-and-up action-button-sm"
                  color="#10940c"
                  dark
                  round
                  @click="submit"
                >
                  {{ modalFormButtonText }}
                </v-btn>

            </v-form>
          </div>

          <div v-else key="two">
            <v-form ref="form">
                <div class="form-name1">Спасибо!</div>
                <div class="form-success">Ваша заявка принята.</div>
                <div class="form-success-phone">{{ phoneSuccess }}</div>
                <div>
                  <small class="small">если номер указан не верно, оставьте заявку повторно</small>
                </div>

                <v-btn
                  class="form-button"
                  color="#10940c"
                  large
                  dark
                  round
                  @click="clear"
                >
                  Ок
                </v-btn>
            </v-form>
          </div>

        </transition>

      </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  props: [
    'ButtonText',
    'modalFormHeader',
    'modalFormSubHeader',
    'modalFormButtonText',
    'formName'
  ],
  data: () => ({
    dialog: false,
    formSuccess: false,
    phone: '',
    phoneSuccess: '',
    phoneRules: [
      v => !!v || 'Поле "Телефон" не заполнено!'
    ]
  }),
  computed: {
    apiEmail () {
      return this.$store.state.apiSendMail
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        axios.post(this.apiEmail, {
          phone: this.phone,
          formName: this.formName
        })
        // phoneSuccess = 'this.$refs.form.phone'
        this.phoneSuccess = this.phone
        this.$refs.form.reset()
        this.formSuccess = !this.formSuccess
      }
    },
    clear () {
      this.dialog = false
      this.formSuccess = !this.formSuccess
    }
  }
}
</script>

<style scoped>
.action-button-sm {
  height: 40px;
}

.form-card {
  padding: 30px 60px;
  text-align: center;
}

.form-name1 {
  font-size: 32px;
}

.form-name2 {
  font-size: 21px;
}

.form-sub-name {
  color: #757575;
  margin-top: 20px;
}

.form-input {
  margin-top: 20px;
}

.form-button {
  margin-top: 20px;
}

.small {
  color: #BDBDBD;
}

.privacy-link {
  color: #BDBDBD;
}

.form-success {
  margin: 15px 0px;
}

.form-success-phone {
  margin: 15px 0px;
  padding: 10px;
  background-color: #c3c3c3;
}

/* TRANSITION */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .form-card {
    padding: 30px 20px;
  }

  .form-name1 {
    font-size: 25px;
  }

  .form-name2 {
    font-size: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ModalForm.vue